import React from "react";
import Context from "../../../Context";
import SuperSelect from "../../Misc/SuperSelect";

import Blocker from "../../Misc/Blocker";
import Modal from "../../Misc/Modal";
import EssenceReferencePositionEdit from "../EssenceReferencePositionEdit";

export default class SchemeModal extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      item: { ...this.props.item },
    };
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.item) !== JSON.stringify(this.props.item)) {
      this.setState({ item: { ...this.props.item } });
    }
  }

  onChange = (id, value) => {
    this.setState((state) => {
      let { item } = state;
      item[id] = value;
      return { item };
    });
  };

  save = async () => {
    const { item } = this.state;
    this.setState({ pending: true });

    const reset = item.id ? this.context.api.nullUuid : null;

    let saveData = {
      id: item.id,
      type: item.type,
      position: item.position || reset,
      activity: item.activity,
      state: item.state,
      structure: item.structure || reset,
      member: item.member || reset,
      splitgroup: item.splitgroup ? true : false,
    };
    let result = await this.context.api.q("/matching/set", saveData);
    this.setState({ pending: false });
    if (result !== false) {
      this.context.toast("Изменения сохранены", "success");
      if (this.props.onAfterSave) {
        this.props.onAfterSave(result);
      }
    } else {
      this.context.toast("Не удалось сохранить изменения", "error");
    }
  };

  render() {
    const { item, pending } = this.state;

    return (
      <>
        <Modal show={this.props.show} onClose={this.props.onModalClose}>
          <Blocker on={pending}>
            {item.typename && (
              <div className="alert alert-light">
                <span className="text-dark mr-2">{item.typename} </span>
                {item.typecode}
              </div>
            )}
            <div className="form-group  ">
              <label>Состояние</label>
              <SuperSelect
                add
                key={item.type}
                defaultValue={item.state}
                onChange={(value) => this.onChange("state", value)}
                anyState
                forcePath="/state/by/type"
                forceQueryParams={{ type: item.type }}
                placeholder="Выберите состояние..."
                nameField="label"
                idField="id"
              />
            </div>
            <div className="form-group  ">
              <label>В структуре организации</label>
              <SuperSelect
                isClearable
                defaultValue={item.structure}
                onChange={(value) => this.onChange("structure", value)}
                essence="structure"
                placeholder="Выберите из списка..."
                nameField="label"
                idField="id"
                type="soc.structure"
                reference={{
                  title: "Структура организации",
                  essence: "structure",
                  showDescription: true,
                  showType: true,
                  forceType: "soc.structure",
                  structure: true,
                }}
              />
            </div>
            <div className="form-group  ">
              <label>Должность</label>
              <SuperSelect
                isClearable
                defaultValue={item.position}
                onChange={(value) => this.onChange("position", value)}
                essence="position"
                placeholder="Выберите должность..."
                nameField="name"
                idField="id"
                reference={{
                  title: "Должности",
                  essence: "position",
                  showDescription: true,
                  showType: true,
                  itemEditor: (itemEditorProps) => (
                    <EssenceReferencePositionEdit {...itemEditorProps} />
                  ),
                }}
              />
            </div>
            <div className="form-group">
              <label>Конкретный сотрудник</label>
              <SuperSelect
                cache
                isClearable
                defaultValue={item.member}
                onChange={(value) => this.onChange("staff", value)}
                essence="staff"
                placeholder="Выберите должность..."
                nameField="label"
                idField="id"
              />
            </div>
            <div className="form-group">
              <label>Действие</label>
              <SuperSelect
                add
                defaultValue={item.activity}
                onChange={(value) => this.onChange("activity", value)}
                essence="activity"
                placeholder="Выберите действие..."
                nameField="name"
                idField="id"
              />
              <div className="form-group">
                <label className="checkbox mt-5">
                  <input
                    onChange={(e) =>
                      this.onChange("splitgroup", e.target.checked)
                    }
                    checked={item.splitgroup ? true : false}
                    type="checkbox"
                  />
                  <span className="mr-4"></span>
                  Разбивать по группам
                </label>
              </div>
            </div>
            <hr />

            <button onClick={this.save} className="btn btn-primary mr-2">
              Сохранить
            </button>
            <button onClick={this.props.onModalClose} className="btn btn-light">
              Отмена
            </button>
          </Blocker>
        </Modal>
      </>
    );
  }
}
